import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { Box, Link, Row, Text } from '@opendoor/bricks-next';

import { EntryComponent } from '../../cms/entries/entries';
import renderAsset from '../../cms/renderer/assets';
import { IComponentIconText } from '../../declarations/contentful';

const pictureIconSize = 42;

const renderIconText = (entry: IComponentIconText) => {
  const fields = entry.fields;
  return (
    <Row gap="$half" p="$half">
      {fields.textIcon ? (
        <Text tag="p" typography="$headerSmall">
          {fields.textIcon}
        </Text>
      ) : (
        fields.pictureIcon && (
          <Box height={pictureIconSize} width={pictureIconSize}>
            {renderAsset({
              src: fields.pictureIcon.fields?.file?.url,
              contentType: fields.pictureIcon.fields?.file?.contentType || 'image/png',
              width: pictureIconSize,
              height: pictureIconSize,
            })}
          </Box>
        )
      )}
      {fields.labelText &&
        documentToReactComponents(fields.labelText, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => {
              return (
                <Text tag="p" typography="$bodyLarge" my="auto">
                  {children}
                </Text>
              );
            },
            [INLINES.HYPERLINK]: (node, children) => {
              return (
                <Link
                  ml="$3"
                  href={node.data.uri}
                  target="_blank"
                  analyticsName="cosmos-articles-icon-text"
                  aria-label=""
                >
                  {children}
                </Link>
              );
            },
          },
        })}
    </Row>
  );
};

const IconText: EntryComponent<IComponentIconText> = {
  render: renderIconText,
};

export default IconText;
